import { useTranslation } from 'react-i18next';
import { PageContainer } from '../page_container';
import { PageHeader } from '../page_header';
import { Button, Flex, Text } from '@mantine/core';
import WestIcon from '@mui/icons-material/West';

export const TermsAndConditions = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation('legal');
  return (
    <PageContainer>
      <Flex
        direction={'column'}
        justify={'space-between'}
        style={{ height: '100%' }}
      >
        <div>
          <PageHeader title={t('terms_and_conditions_title')} />
          <Text>{t('terms_and_conditions_message')}</Text>
        </div>
        <Flex direction={'row'} style={{ marginBottom: '5px' }}>
          <Button variant={'back'} size="lg" onClick={onClose}>
            <WestIcon htmlColor="var(--mantine-primary-color-filled)" />
          </Button>
        </Flex>
      </Flex>
    </PageContainer>
  );
};
